import { useCallback, useMemo } from 'react'

import { useDownloadExportFile } from '@features/exports/hooks/useDownloadExportFile'
import { type ExportDocumentFileType } from '@features/exports/types/exportDocumentFileType'

import { useSegment } from '../../../hooks'

const CONTACTS_EXPORT_URL = 'contacts'

interface ExportContactsOptions {
  isCustomerOnly?: boolean
}

export const useExportContacts = () => {
  const { downloadExportFile } = useDownloadExportFile()
  const { track } = useSegment()

  const exportContacts = useCallback(
    (fileType: ExportDocumentFileType, options: ExportContactsOptions = {}) => {
      const { isCustomerOnly } = options

      downloadExportFile({
        exportUrl: CONTACTS_EXPORT_URL,
        type: fileType,
        queryParams: { isCustomerOnly },
      })

      track('Contact List Exported (Client)', { fileFormat: fileType })
      /* eslint-disable @typescript-eslint/naming-convention -- Segment exports event properties are snake_case */
      track('XXX - Mikkel - Exports', {
        export_type: 'Contacts',
        file_format: fileType,
      })
      /* eslint-enable @typescript-eslint/naming-convention */
    },
    [downloadExportFile, track],
  )

  return useMemo(() => ({ exportContacts }), [exportContacts])
}
